import React from 'react';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  const styles = {
    container: {
      display: 'flex',
      minHeight: 'calc(100vh - 111px)', // ปรับจาก 80px เป็น 111px (21px + 90px)
      backgroundColor: '#f8f9fa',
    },
    mainContent: {
      flex: 1,
      padding: '30px',
      overflowY: 'auto',
    },
  };

  return (
    <div style={styles.container}>
      <Sidebar />
      <main style={styles.mainContent}>
        {children}
      </main>
    </div>
  );
};

export default Layout; 